export const postpone = (timeout = 10) =>
  new Promise(resolve => setTimeout(resolve, timeout));
